import React from 'react'
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';

class FormSelect extends React.PureComponent {
  render() {
    const {id, label, helperText, className, selectclass, error, ...other} = this.props
    return (
      <FormControl className={className}>
        <InputLabel htmlFor={id}>{label}</InputLabel>
        <Select id={id} {...other} className={`formControlSelect`} />
        <FormHelperText error={error} classes={{error: 'TextInput-error'}}>{helperText}</FormHelperText>
      </FormControl>
    )
  }
}

export default FormSelect



// WEBPACK FOOTER //
// ./src/js/components/inputs/FormSelect.js